import { gql } from 'graphql-request';
import { InviteLinkFragment } from './inviteLinkFragment';
import { ClientInvitationFragment } from './clientInvitationFragment';
import { FirmClientListItemFragment } from './firmClientListItemFragment';

/**
 * Full FirmClient shape for the client-DETAIL path (and self/household
 * queries). Composes `FirmClientListItemFragment` (the shared list shape) and
 * adds the heavy per-client selections that list views must not fetch.
 */
export const FirmClientFragment = gql`
  ${FirmClientListItemFragment}
  ${InviteLinkFragment}
  ${ClientInvitationFragment}
  fragment FirmClientFragment on FirmClient {
    ...FirmClientListItemFragment
    firmID
    changeToken
    status
    activeFeatureDiscoveryTriggers
    elementVisibilityOverrides {
      element
      visible
    }
    pendingInvitations {
      ...ClientInvitationFragment
    }
    originFirmInviteLink {
      ...InviteLinkFragment
    }
    notes {
      id
      tenantID
      latestDataPoint {
        id
        data {
          __typename
          ... on StringDataPointValue {
            value
          }
        }
      }
    }
    household {
      id
      householdID
      ownerID
      financialCategorization
      financialCategoryScore
      financialPurpose {
        id
        tenantID
        latestDataPoint {
          id
          data {
            __typename
            ... on StringDataPointValue {
              value
            }
          }
        }
      }
      income {
        id
        latestDataPoint {
          ... on RecurringMonetaryAmountDataPoint {
            data {
              __typename
              value {
                amount {
                  value
                  currencyCode
                }
                frequency
              }
            }
          }
        }
      }
      spending {
        id
        tenantID
        updatedAt
        latestDataPoint {
          dateTime
          ... on RecurringMonetaryAmountDataPoint {
            data {
              __typename
              value {
                amount {
                  value
                  currencyCode
                }
                frequency
              }
            }
          }
        }
      }
    }
    individuals {
      relationship
    }
    team {
      role
      __typename
      member {
        id
        calendarSchedulingLink
        familyName
        givenName
        profileColor
      }
    }
  }
`;
